import { Box, Typography } from "@mui/material";

import { colors, typeScale } from "../theme/tokens";

import type { WidgetProps } from "./types";

// The leadership team as the website's About page shows it (Bill,
// 2026-09-08): a square headshot over the name and the role, one card per
// person, static 1px-line cards. The people and photos are the site's
// `team` list, headshots copied from its processed set into
// public/brand/team/. The role line is the capability the person leads.
export function TeamGrid({ widget }: WidgetProps<"team_grid">) {
    const { title, intro, members } = widget.props;

    return (
        <Box>
            {title && (
                <Typography variant="h4" sx={{ mb: intro ? 0.5 : 2 }}>
                    {title}
                </Typography>
            )}
            {intro && (
                <Typography variant="body1" sx={{ color: "text.secondary", ...typeScale.lead, mb: 3, maxWidth: 1064 }}>
                    {intro}
                </Typography>
            )}
            {/* Flex wrap, not a grid, so a partial last row centres (Bill,
                2026-09-08), the same reason the site's team list wraps. */}
            <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 3 }}>
                {members.map((m) => (
                    <Box
                        key={m.name}
                        sx={{
                            width: { xs: "calc(50% - 12px)", sm: "calc(33.333% - 16px)", md: 176 },
                            border: 1,
                            borderColor: colors.line,
                            borderRadius: "10px",
                            bgcolor: "background.paper",
                            overflow: "hidden",
                            textAlign: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={m.photoUrl}
                            alt={m.name}
                            loading="lazy"
                            sx={{ display: "block", width: "100%", aspectRatio: "1 / 1", objectFit: "cover" }}
                        />
                        <Box sx={{ px: 1.5, pt: 1.5, pb: 2 }}>
                            <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: colors.navy }}>
                                {m.name}
                            </Typography>
                            <Typography sx={{ fontSize: "0.75rem", color: "text.secondary", mt: 0.25 }}>
                                {m.role}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
